var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70123 1.69298C7.08849 1.30572 7.08849 0.677795 6.70123 0.290536C6.31385 -0.0968452 5.68605 -0.0968452 5.29867 0.290536L0.290445 5.29877C-0.096815 5.68603 -0.096815 6.31395 0.290445 6.7012L5.29867 11.7096C5.68605 12.0968 6.31385 12.0968 6.70123 11.7096C7.08849 11.3223 7.08849 10.6944 6.70123 10.3071L2.39417 6.00005L6.70123 1.69298Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.dc4add7def9602888511f37960f28277.svg";
export { ForwardRef as ReactComponent };